/**
 * @module components\ghInput\checkInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";

@Component
export default class CheckInput extends InputBase {}
